// „Zu prüfen" — vom Watch-Cron entdeckte Review-Kandidaten (users/{uid}/walletCandidates).
//
// Diese Dokumente sind KEINE Transaktionen. Sie werden vom täglichen Cron
// (api/alert-cron.js) angelegt und hier nur GELESEN/GELÖSCHT. Erst wenn der User
// einen Kandidaten im ImportReviewScreen bestätigt, wird daraus über den
// vorhandenen Import-Pfad (addBatch) eine echte Transaktion — der Read-Layer +
// FIFO bleiben die einzige Wahrheit.

import { collection, getDocs, deleteDoc, doc } from '../lib/fsCompat';
import { db } from '../firebase';

/** Alle offenen Kandidaten des Users (status === 'pending'), neueste zuerst. */
export async function listCandidates(uid) {
  if (!uid) return [];
  const snap = await getDocs(collection(db, 'users', uid, 'walletCandidates'));
  return snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .filter(c => c.status !== 'dismissed' && c.status !== 'imported')
    .sort((a, b) => String(b.foundAt || '').localeCompare(String(a.foundAt || '')));
}

/** Einen Kandidaten entfernen (verworfen ODER nach erfolgreichem Import). */
export async function deleteCandidate(uid, id) {
  if (!uid || !id) return;
  await deleteDoc(doc(db, 'users', uid, 'walletCandidates', id));
}

/** Mehrere Kandidaten entfernen (best-effort, einzelne Fehler ignoriert). */
export async function clearCandidates(uid, ids = []) {
  if (!uid || !ids.length) return;
  await Promise.all(ids.map(id => deleteCandidate(uid, id).catch(() => {})));
}
